import { useDispatch } from 'react-redux';
import {
  AppDispatch,
  submitClick
} from '../../../../../store';

export const useSubmit = () => {
  const dispatch: AppDispatch = useDispatch();

  const onClick = () => {
    dispatch(submitClick());
  };

  return {
    onClick
  };
};
